import { Component } from 'react';
import classNames from 'classnames/bind';
import { clsx } from 'clsx';
import PropTypes from 'prop-types';
import styles from './NameValueTable.module.css';

const cx = classNames.bind(styles);

class NameValueTable extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        title: PropTypes.string,
        value: PropTypes.string,
        info: PropTypes.string,
      }),
    ).isRequired,
    noBold: PropTypes.bool,
    highlightName: PropTypes.bool,
    boldValue: PropTypes.bool,
    discountValue: PropTypes.bool,
    responsiveText: PropTypes.bool,
    compact: PropTypes.bool,
  };

  static defaultProps = {
    highlightName: true,
    noBold: false,
    boldValue: false,
    discountValue: false,
    responsiveText: true,
    compact: false,
  };

  render() {
    const {
      items,
      boldValue,
      noBold,
      highlightName,
      discountValue,
      responsiveText,
      compact,
    } = this.props;

    return (
      <div className={cx('name-value-table')}>
        {items.map((item, index) => (
          <div
            key={index}
            className={clsx(
              'relative',
              items.length > 1 && (compact ? 'mb-xs' : 'mb-lg'),
            )}
          >
            {item.title && <div className={cx('title')}>{item.title}</div>}
            <div className={cx('row', { 'responsive-text': responsiveText })}>
              <div
                className={cx(
                  'name',
                  { noBold },
                  { 'no-highlight': !highlightName },
                  { 'margin-left': !!item.title },
                )}
              >
                {item.name}
              </div>
              <div
                className={cx(
                  'right',
                  { bold: boldValue },
                  { discount: discountValue },
                )}
              >
                {item.value}
              </div>
            </div>
            {item.info && (
              <div className="mt-5 absolute left-0 top-full max-w-[68vw] text-p1 text-dark-gray">
                {item.info}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }
}

NameValueTable.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      title: PropTypes.string,
      value: PropTypes.string,
    }),
  ).isRequired,
  noBold: PropTypes.bool,
  highlightName: PropTypes.bool,
  boldValue: PropTypes.bool,
  discountValue: PropTypes.bool,
  responsiveText: PropTypes.bool,
  compact: PropTypes.bool,
};

export default NameValueTable;
